import { useDispatch } from 'react-redux';
import {
	Col,
	Alert,
	Spinner,
	CardBody,
	Card,
	CardHeader,
	Row,
} from 'reactstrap';
import { Link, useNavigate } from 'react-router-dom';
import { createSelector } from 'reselect';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { ODataGrid } from '../../../Components/OElements/ODataGrid';
import AddEditFuelTankModal from './Add_Edit/AddEditFuelTank';
import DeleteFuelTankModal from './Delete/DeleteFuelTank';
import { getFuelTankList } from '../../../slices/fuelTank/thunk';

const FuelTankList = () => {
	const dispatch = useDispatch();
	const history = useNavigate();

	const selectorFuelTank = createSelector(
		state => state.FuelTank,
		data => ({
			fuelTankList: data.fuelTankList,
			isLoadingList: data.isLoadingList,
			isFuelTankSuccess: data.isFuelTankSuccess,
			error: data.error,
			isAdding: data.isAdding,
			isAdded: data.isAdded,
			isAddError: data.isAddError,
			isUpdating: data.isUpdating,
			isUpdated: data.isUpdated,
			isUpdateError: data.isUpdateError,
			isDeleting: data.isDeleting,
			isDeleted: data.isDeleted,
			isDeleteError: data.isDeleteError,
		})
	);

	// const selectRolesList = createSelector(
	// 	state => state.Roles.rolesListSelect,
	// 	rolesListSelect => rolesListSelect
	// );

	// const rolesListSelect = useSelector(selectRolesList);

	const { fuelTankList, isLoadingList } = useSelector(selectorFuelTank);

	useEffect(() => {
		dispatch(getFuelTankList());
	}, []);

	const [dataFuelTank, setDataFuelTank] = useState({});
	const [isEdit, setIsEdit] = useState(false);

	// Delete FuelTank
	const [modal, setModal] = useState(false);
	const [modalDelete, setModalDelete] = useState(false);
	//Tab
	const [activeTab, setActiveTab] = useState('1');
	const toggleTab = tab => {
		if (activeTab !== tab) {
			setActiveTab(tab);
		}
	};

	function handleToggleModal() {
		setModal(!modal);
		toggleTab('1');
		// validation.resetForm();
	}

	function handleToggleModalDelete() {
		setModalDelete(!modalDelete);
	}

	// Delete Data
	const handleClickDelete = fuelTank => {
		setDataFuelTank(fuelTank);
		setModalDelete(true);
	};

	// Update Data
	const handleClickEdit = fuelTank => {
		setDataFuelTank(fuelTank);
		handleToggleModal();
	};

	const columns = useMemo(
		() => [
			{
				header: 'Acciones', enableSorting: false, enableColumnFilter: false, enableGlobalFilter: false, enableColumnActions: false,
				accessorKey: 'fuelTank',
				columnDefType: 'display',
				size: 'auto',
				Cell: cellProps => {
					return (
						<React.Fragment>
							<div className='d-flex'>
								<div className='flex-shrink-0'>
									<ul className='list-inline mb-0'>
										<li className='list-inline-item'>
											<Link
												to='#'
												onClick={() => {
													const fuelTankData =
														cellProps.row.original;
													setIsEdit(true);
													handleClickEdit(fuelTankData);
												}}
											>
												<i className='ri-pencil-fill align-bottom me-2 text-muted'></i>
											</Link>
										</li>
										<li className='list-inline-item'>
											<Link
												to='#'
												className='remove-item-btn'
												onClick={() => {
													const fuelTankData =
														cellProps.row.original;
													handleClickDelete(fuelTankData);
												}}
											>
												<i className='ri-delete-bin-line align-bottom me-2 text-muted'></i>
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</React.Fragment>
					);
				},
			},

			{ header: 'Nombre', accessorKey: 'name' },
			{
				header: 'Artefacto Naval',
				accessorKey: 'feeding_barges.name',
				dataType: 'multi-select',
				size: 'auto',
				Cell: ({ row }) => {
					const establishmentType = row?.original?.establishment_type?.code;
					const feedingBargeName = row?.original?.feeding_barges?.name;

					return feedingBargeName
						? feedingBargeName
						: establishmentType !== 'SWE'
						? 'N/A'
						: '-';
				},
			},
			{
				header: 'Establecimiento',
				accessorKey: 'establishment.name',
				dataType: 'multi-select',
				Cell: ({ row }) => {
					const establishmentData =
						row?.original?.feeding_barges?.establishment ||
						row?.original?.establishment;
					const establishmentName =
						establishmentData?.name || '-';
					const establishmentId =
						establishmentData?._id || row?.original?.establishment_id;

					return establishmentId && row?.original?.establishment?.name ? (
						<span
							onClick={() =>
								window.open(
									`/establishment/summary/${establishmentId}`,
									'_blank'
								)
							}
							style={{
								cursor: 'pointer',
								color: 'var(--vz-primary)',
								textDecoration: 'none',
								fontWeight: 'bold',
							}}
						>
							<i className='ri-links-line'></i> {establishmentName}
						</span>
					) : (
						<span>{establishmentName}</span>
					);
				},
			},
			{
				header: 'Tipo de Establecimiento',
				accessorKey: 'establishment_type.name',
				dataType: 'multi-select',
				size: 'auto',
				Cell: ({ row }) => {
					return row?.original?.establishment_type?.name
						? row.original.establishment_type.name
						: '-';
				},
			},
			{
				header: 'Código SIEP',
				accessorKey: 'establishment.code_siep',
				dataType: 'multi-select',
				Cell: ({ row }) => {
					const establishmentData =
						row?.original?.feeding_barges?.establishment ||
						row?.original?.establishment;
					const establishmentCode = establishmentData?.code_siep || '-';
					return establishmentCode;
				},
			},
			{
				header: 'Tipo de combustible',
				accessorKey: 'fuel_type.name',
				dataType: 'multi-select',
			},
			{
				header: 'Capacidad',
				accessorKey: 'capacity',
				dataType: 'separator',
			},
			{
				header: 'Saldo Actual',
				accessorKey: 'stock',
				dataType: 'separator',
			},
			{
				header: 'Unidad de Medida',
				accessorKey: 'unit_measurement.name',
				dataType: 'multi-select',
			},
			{ header: 'Descripción', accessorKey: 'description' },
		],
		[handleClickEdit]
	);

	return (
		<React.Fragment>
			<Row>
				<Col lg={12}>
					<Card>
						{/* <CardHeader className='border-0 pb-0'>
							<div className='d-flex align-items-end justify-content-end'>
								<div className='flex-shrink-0'>
									<div className='d-flex flex-wrap gap-2'>
										<button
											className='btn btn-label btn-primary'
											onClick={() => {
												setIsEdit(false);
												setDataFuelTank({});
												handleToggleModal();
											}}
										>
											<i className={`${Icons.plus} label-icon`}></i>{' '}
											Crear Estanque de Combustible
										</button>
									</div>
								</div>
							</div>
						</CardHeader> */}
						<CardBody>
							<ODataGrid
								columns={columns}
								data={fuelTankList || []}
								isLoadingData={isLoadingList}
								nameFile={'estanque_de_combustible'}
								customToolbarActions={[
									{
										label: 'Crear',
										icon: Icons.plus,
										onClick: () => {
											setIsEdit(false);
											setDataFuelTank({});
											handleToggleModal();
										},
										title: 'Crear Estanque de Combustible'
									}
								]}
							/>
						</CardBody>
					</Card>
				</Col>
			</Row>

			<AddEditFuelTankModal
				dataFuelTank={dataFuelTank}
				isEdit={isEdit}
				isOpen={modal}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
			/>
			<DeleteFuelTankModal
				dataFuelTank={dataFuelTank}
				isOpen={modalDelete}
				handlerToggleModal={handleToggleModalDelete}
			/>
		</React.Fragment>
	);
};

export default FuelTankList;
